<script setup lang="ts">
const props = defineProps(['showSpinner', 'compact', 'title']);
const { showSpinner, compact, title } = toRefs(props);
</script>
<template>
  <button
    :class="[compact ? 'px-2' : 'px-4']"
    :title="title"
    class="text-md betterhover:hover:shadow-card-hover dark:text-neutral-white flex w-full justify-center rounded-full border border-transparent bg-black py-2 font-medium text-white transition duration-100 ease-in-out dark:bg-neutral-800 betterhover:hover:-translate-y-0.5"
  >
    <svg
      v-if="showSpinner"
      :class="[compact ? 'h-5 w-5' : '-ml-1 mr-2 h-6 w-6']"
      class="animate-spin text-white dark:text-black"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    <svg v-else :class="[compact ? 'h-5 w-5' : '-ml-1 mr-2 h-6 w-6']" viewBox="0 0 28 20">
      <g clip-path="url(#a)">
        <path
          d="M7.386 6.482c3.653-3.576 9.575-3.576 13.228 0l.44.43a.451.451 0 0 1 0 .648L19.55 9.033a.237.237 0 0 1-.33 0l-.606-.592c-2.548-2.496-6.68-2.496-9.228 0l-.648.634a.237.237 0 0 1-.33 0L6.902 7.602a.451.451 0 0 1 0-.647l.483-.473Zm16.338 3.046 1.339 1.31a.451.451 0 0 1 0 .648l-6.035 5.909a.475.475 0 0 1-.662 0L14.083 13.2a.119.119 0 0 0-.166 0l-4.283 4.194a.475.475 0 0 1-.662 0l-6.035-5.91a.451.451 0 0 1 0-.647l1.338-1.31a.475.475 0 0 1 .662 0l4.283 4.194c.046.044.12.044.166 0l4.283-4.194a.475.475 0 0 1 .662 0l4.283 4.194c.046.044.12.044.166 0l4.283-4.194a.475.475 0 0 1 .662 0Z"
          fill="#ffffff"
        ></path>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#ffffff" d="M0 0h28v20H0z"></path>
        </clipPath>
      </defs>
    </svg>
    <slot />
  </button>
</template>
